export default __webpack_public_path__ + "static/media/kfcmw.92cc2287.jpg";